module.exports = __webpack_public_path__ + "static/media/IconTemplates_-53.0adcb5bd.svg";